import { render, staticRenderFns } from "./documentsstatistics.vue?vue&type=template&id=ca4c5ffc"
import script from "./documentsstatistics.vue?vue&type=script&lang=js"
export * from "./documentsstatistics.vue?vue&type=script&lang=js"
import style0 from "./documentsstatistics.vue?vue&type=style&index=0&id=ca4c5ffc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports